import { createDraftSafeSelector } from "@reduxjs/toolkit";
import {
  HighchartsChartDataSeriesOption,
  HighchartsChartDataType,
} from "@/storybook/c8r-highcharts/common/utils/types/common";
import { budgetSeriesName } from "@/components/pages/common/billing-explorer/utils/addBudgetLineIntoBillingExplorerChartData";
import { budgetDetailsHistoryProcessedDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";

export const budgetDetailsHistoryChartDataSelector = createDraftSafeSelector(
  [budgetDetailsHistoryProcessedDataSelector],
  (processedData): HighchartsChartDataType | null => {
    if (!processedData) {
      return null;
    }

    const categories: string[] = processedData.map(
      ({ formatedDate }) => formatedDate,
    );

    let prevUsedValue = 0;

    const usedSeries: HighchartsChartDataSeriesOption = {
      name: "Used",
      color: "#72BEF4",
      type: "column",
      data: processedData.map(({ used }) => {
        if (typeof used !== "number") {
          return {
            y: prevUsedValue,
            ...emptyUsedConfigs,
          };
        } else {
          prevUsedValue = used;
        }

        return { y: used ?? 0 };
      }),
    };

    const budgetSeries: HighchartsChartDataSeriesOption = {
      name: budgetSeriesName,
      type: "line",
      color: "red",
      dashStyle: "Dash",
      step: "center",
      data: processedData.map(({ budget }) => ({ y: budget ?? 0 })),
      marker: { enabled: false },
      lineWidth: 2,
      purpose: "visualization",
    };

    return {
      categories,
      series: [usedSeries, budgetSeries],
    };
  },
);

const emptyUsedConfigs = {
  color: "#E1E1E1",
  borderWidth: 1,
  borderColor: "#9E9E9E",
  dashStyle: "Dash",
  states: {
    hover: {
      color: "#EDEDED",
    },
  },
};
